var _style, _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEsperionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "layer",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 652 652",
    style: {
      enableBackground: "new 0 0 652 652"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#007BC3;}\r\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 21.1,
    y: 314.7,
    className: "st0",
    width: 14.4,
    height: 44.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.1,282.8h56.4v12.8H21.1V282.8z M21.1,314.7h56.2v12.8H21.1V314.7z M21.1,346.4h56.2v12.8H21.1V346.4z  M109.7,303.3c0-5.6,4.9-9.1,11.7-9.1c7.2,0,13.7,3,18.2,6.5l7.9-11c-6.8-5.4-15.8-8.6-26.1-8.6c-14.7,0-26.8,8.6-26.8,21.9 c0,32.9,41,14.7,41,34c0,6.5-5.6,11-14,11c-7.9,0-15.6-3.5-20.5-7.9l-7.9,11.4c7.2,6.1,17.5,9.8,28.4,9.8c15.8,0,29.1-9.6,29.1-23.8 C150.7,304.7,109.7,320.8,109.7,303.3 M204.8,282.8h-35.9v76.4h14.4V335h21.2c14.7,0,26.8-11,26.8-26.1S219.9,282.8,204.8,282.8  M204.8,322.2h-21.2v-26.6h21.2c6.8,0,11.7,6.1,11.7,13.3S211.8,322.2,204.8,322.2 M247.6,359.2h56.2v-12.8h-56.2V359.2z  M247.6,359.2h56.2v-12.8h-56.2V359.2z M247.6,327.6h56.2v-12.8h-41.7v-19.1h41.7v-12.8h-56.2V327.6z M385.8,308.9 c0-15.1-12.1-26.1-26.8-26.1h-35.9v76.4h14.4V335h17.7l16.3,24.2h16.3l-17.7-26.6C379.5,328.7,385.8,319.9,385.8,308.9 M359,322.2 h-21.2v-26.6H359c6.8,0,11.7,6.1,11.7,13.3S365.5,322.2,359,322.2 M402.8,282.8h14.4v76.4h-14.4V282.8z M476.5,281 c-23.1,0-41.7,17.5-41.7,40.1c0,22.6,18.6,40.1,41.7,40.1c23.1,0,41.7-17.5,41.7-40.1C518.2,298.4,499.1,281,476.5,281 M476.5,348.1 c-14.7,0-26.6-12.1-26.6-26.8c0-14.7,11.7-26.8,26.6-26.8c14.7,0,26.6,12.1,26.6,26.8C503,336.2,491.1,348.1,476.5,348.1  M586.9,282.8v44h-0.2L535.2,281v78.3h14.2v-43.8l0,0l52,45.9v-78.5H586.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "cRight",
    className: "st0",
    d: "M621.2,287.7c0-3.5-3-6.5-6.5-6.5c-3.7,0-6.5,3-6.5,6.5c0,3.7,3,6.5,6.5,6.5 C618.1,294.2,621.2,291.2,621.2,287.7 M620.2,287.7c0,3.5-2.6,5.6-5.6,5.6c-3.5,0-5.6-2.6-5.6-5.6s2.6-5.6,5.6-5.6 C617.7,281.7,620.2,284.5,620.2,287.7 M618.1,291.7l-1.6-3.5c1.2-0.5,1.6-1.6,1.6-2.6c0-1.6-1.2-2.6-2.6-2.6h-3.7v8.4h1.6v-2.8h1.9 l1.6,3C616.5,291.7,618.1,291.7,618.1,291.7z M613.2,287v-2.3h2.3c0.7,0,1.2,0.5,1.2,1.2s-0.5,1.2-1.2,1.2H613.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEsperionIcon);
export default __webpack_public_path__ + "static/media/esperion-icon.f1f119afbd312c68747db927a8f13065.svg";
export { ForwardRef as ReactComponent };